import { c as _c } from "react/compiler-runtime";
import { useIsVisible } from "@website/hooks/is-visible";
import { useViewPort } from "@website/hooks/viewport";
import { MaterialIcon } from "@website/icons/material";
import { USER_TRACKING_EVENTS } from "@website/tracking/tracking.types";
import { Button } from "@website/ui/button";
import { CollapsibleText } from "@website/ui/collapsible-text";
import { Loading } from "@website/ui/loading";
import { ReserveComment } from "@website/widget/reserve-comment";
import { ReserveCommentsFilter } from "@website/widget/reserve-comment-popup-scroll/reserve-comment-filter";
import { ReserveCommentsFilterEmptyResult } from "@website/widget/reserve-comment-popup-scroll/reserve-comment-filter/reserve-comment-filter-empty-result";
import { ReserveCommentPopupScrollTypes } from "@website/widget/reserve-comment-popup-scroll/reserve-comment-popup-scroll.types";
import { ReserveRate } from "@website/widget/reserve-rate";
import isEmpty from "lodash-es/isEmpty";
import { useRouter } from "next/router";
import { useEffect } from "react";
const MAX_COMMENTS_COUNT = 5;
export const ReserveCommentPopupScroll = t0 => {
  const $ = _c(39);
  const {
    rate,
    comments,
    onLoadMore,
    isLoading,
    className,
    onLoadFilter,
    filters,
    isInsideDetail,
    size: t1,
    onClick
  } = t0;
  const size = t1 === undefined ? "normal" : t1;
  const router = useRouter();
  const {
    isMobile
  } = useViewPort();
  const {
    reference,
    inView
  } = useIsVisible();
  let t2;
  let t3;
  if ($[0] !== inView || $[1] !== onLoadMore) {
    t2 = () => {
      inView && onLoadMore?.();
    };
    t3 = [inView, onLoadMore];
    $[0] = inView;
    $[1] = onLoadMore;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  useEffect(t2, t3);
  const t4 = `${size === "small" ? "" : "h-[calc(100%-64px)]"} ${className}`;
  const t5 = `${size === "small" ? "mx-0 pt-6 md:gap-4 xl:flex-col" : "px-6 py-4 md:gap-[40px] xl:mx-auto xl:flex-row"} relative flex w-full flex-col items-center gap-4 self-stretch md:items-start md:pb-[40px] md:pt-6 xl:max-w-[1200px]`;
  let t6;
  if ($[4] !== rate || $[5] !== size) {
    t6 = rate && <div className={`${size === "small" ? "flex-col md:flex-row" : "flex-col xl:sticky xl:top-0 xl:min-w-[312px] xl:max-w-[312px] xl:pt-[40px]"} mx-auto flex w-full flex-auto gap-6`}><ReserveRate {...rate} hasBackground={false} showFooter={size !== "small"} showTitle={false} size="medium" /><div className="bg-dim-background h-px w-full xl:hidden" />{rate?.aiSummary && size === "small" && <div className="bg-dim-background text-subtitle-2 flex min-w-[305px] flex-col gap-2 rounded-lg px-3 py-4"><CollapsibleText ariaLabel="description" className={`${size === "small" ? "max-h-[305px] overflow-y-auto" : ""} text-on-surface-high-emphasis`} collapsedClassName={size === "small" ? "h-[145px]" : "h-[118px]"} content={rate?.aiSummary} disableScrollWhenCollapsed={true} eventKey={USER_TRACKING_EVENTS?.AI_SUMMARY_COMMENTS as const} isHtml={true} /><div className="bg-transparent-secondary text-caption mt-auto flex flex-row items-center gap-1 rounded-lg p-2"><MaterialIcon className="text-secondary text-subtitle-1" name="edit" variant="outlined" /><span>برگرفته از نظرات مهمانان واقعی که توسط هوش مصنوعی خلاصه شده است.</span></div></div>}</div>;
    $[4] = rate;
    $[5] = size;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== comments?.length || $[8] !== onClick || $[9] !== size) {
    t7 = size === "small" && <div className="flex w-full flex-row items-center justify-between"><span className="text-subtitle-1">نظرات اخیر کاربران</span>{comments?.length >= MAX_COMMENTS_COUNT && <Button color="secondary" onClick={onClick} text={"\u0646\u0638\u0631\u0627\u062A \u0628\u06CC\u0634\u062A\u0631"} variant="outline" />}</div>;
    $[7] = comments?.length;
    $[8] = onClick;
    $[9] = size;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== filters || $[12] !== isInsideDetail || $[13] !== onLoadFilter) {
    t8 = !isEmpty(filters) && <div className="z-10 mr-[-4px] w-[103%] bg-white pb-2 pe-3 ps-1 xl:sticky xl:top-0"><ReserveCommentsFilter filters={filters} isInsideDetail={isInsideDetail} onLoadFilter={onLoadFilter} /></div>;
    $[11] = filters;
    $[12] = isInsideDetail;
    $[13] = onLoadFilter;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== comments || $[16] !== filters || $[17] !== isLoading || $[18] !== onLoadFilter || $[19] !== router?.query) {
    t9 = !isEmpty(filters) && !isLoading && !comments?.length && Boolean(Object.keys(router?.query)?.filter(_temp).length) ? <div className="pt-[60px]"><ReserveCommentsFilterEmptyResult onLoadFilter={onLoadFilter} /></div> : comments?.map(_temp2);
    $[15] = comments;
    $[16] = filters;
    $[17] = isLoading;
    $[18] = onLoadFilter;
    $[19] = router?.query;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== isLoading || $[22] !== isMobile) {
    t10 = isLoading && <div className="mx-auto"><Loading color="primary" size={isMobile ? "sm" : "lg"} /></div>;
    $[21] = isLoading;
    $[22] = isMobile;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== reference) {
    t11 = <div ref={reference} />;
    $[24] = reference;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] !== t10 || $[27] !== t11 || $[28] !== t8 || $[29] !== t9) {
    t12 = <div className="relative flex w-full flex-col gap-6 md:self-start">{t8}{t9}{t10}{t11}</div>;
    $[26] = t10;
    $[27] = t11;
    $[28] = t8;
    $[29] = t9;
    $[30] = t12;
  } else {
    t12 = $[30];
  }
  let t13;
  if ($[31] !== t12 || $[32] !== t5 || $[33] !== t6 || $[34] !== t7) {
    t13 = <div className={t5}>{t6}{t7}{t12}</div>;
    $[31] = t12;
    $[32] = t5;
    $[33] = t6;
    $[34] = t7;
    $[35] = t13;
  } else {
    t13 = $[35];
  }
  let t14;
  if ($[36] !== t13 || $[37] !== t4) {
    t14 = <div className={t4} id="container">{t13}</div>;
    $[36] = t13;
    $[37] = t4;
    $[38] = t14;
  } else {
    t14 = $[38];
  }
  return t14;
};
function _temp(item) {
  return item?.startsWith("filter_");
}
function _temp2(comment) {
  return <ReserveComment key={comment?.id} {...comment} />;
}